import { Tin } from "./Tin";
export class FinnishTin extends Tin {
    validate(tin) {
        return (tin === null || tin === void 0 ? void 0 : tin.length) === 11 && this.validDate(tin) && this.validChecksum(tin);
    }
    getNormalizedTin() {
        return this.tin.toLocaleUpperCase();
    }
    getCentury(tin) {
        const c = tin.toUpperCase().substr(6, 1);
        const centuries = {
            "+": 1800,
            "-": 1900,
            A: 2000,
        };
        return centuries[c] || undefined;
    }
    validDate(tin) {
        const dd = parseInt(tin.substr(0, 2), 10);
        const mm = parseInt(tin.substr(2, 2), 10);
        const yy = parseInt(tin.substr(4, 2), 10);
        const century = this.getCentury(tin);
        if (!century) {
            return false;
        }
        if (yy < 0 || yy > 99) {
            return false;
        }
        if (mm < 1 || mm > 12) {
            return false;
        }
        if (dd < 1 || dd > this.daysInMonth(century + yy, mm)) {
            return false;
        }
        return true;
    }
    validChecksum(tin) {
        const q = tin.toUpperCase().substr(10, 1);
        const num = parseInt(tin.substr(0, 6) + tin.substr(7, 3), 10);
        const reminder = (num / 31) % 1;
        const control = Math.round(reminder * 31);
        const controlLookup = "0123456789ABCDEFHJKLMNPRSTUVWXY";
        if (controlLookup[control] !== q) {
            return false;
        }
        return true;
    }
    daysInMonth(year, month) {
        return new Date(year, month, 0).getDate();
    }
    getBirthDate() {
        if (!this.valid) {
            return undefined;
        }
        const tin = this.tin;
        const century = this.getCentury(tin);
        if (!century) {
            return undefined;
        }
        const yy = parseInt(tin.substr(4, 2), 10);
        return century + yy + "-" + tin.slice(2, 4) + "-" + tin.slice(0, 2);
    }
}
